import dateFormat from "./DateFormat.service"

export const tableDate = (date) => {
    let formatDate = date ? date.split('-') : ""
    formatDate = formatDate ? formatDate[1] + '-' + formatDate[0] + '-' + formatDate[2] : ""
    let newDate = formatDate ? Date.parse(formatDate) : ""
    return newDate
}

export const timeToDate = (time) => {
    let newDate = time
    if (newDate) {
        let date = new Date(time)
        newDate = dateFormat(date)
    }
    return newDate
}

